import * as React from 'react';
import { defaultPrimaryDimensionDirection, primaryDimensionDirectionContext, } from './context';
export var PrimaryDimensionDirectionContextProvider = function (props) {
    var _a = props.primaryDimensionDirection, primaryDimensionDirection = _a === void 0 ? defaultPrimaryDimensionDirection : _a, children = props.children;
    return (React.createElement(primaryDimensionDirectionContext.Provider, { value: primaryDimensionDirection }, children));
};
